import isSSR from "venuescanner-js/services/isSSR";
export default () =>
  isSSR() ? true : window.matchMedia("(min-width: 1200px)").matches;
